export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7901.b28e5823.jpg";